import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';

const Banner = (props) => {
     const { title, description, scrollSection, bgImageUrl, trainingPathway, classNameWrapper } = props;

     const [windowSize, setWindowSize] = useState(getWindowSize());

     useEffect(() => {
          const handleWindowResize = () => {
               setWindowSize(getWindowSize());
          };
          window.addEventListener('resize', handleWindowResize);

          return () => {
               window.removeEventListener('resize', handleWindowResize);
          };
     }, []);

     const isMobile = useMemo(() => {
          return windowSize.innerWidth <= 767;
     }, [windowSize]);

     function getWindowSize() {
          const { innerWidth } = window;
          return { innerWidth };
     }

     const handleClickScrollSection = () => {
          const scrollSectionElement = document.querySelector(scrollSection.href);
          const headerElement = document.querySelector('.header-main');

          if (scrollSectionElement && headerElement) {
               const navbarHeight = headerElement.getBoundingClientRect().height;
               const elementPosition = scrollSectionElement.getBoundingClientRect().top + window.scrollY;
               window.scrollTo({
                    top: elementPosition - navbarHeight,
                    behavior: 'smooth',
               });
          }
     };

     return (
          <section
               className={classNames('section-banner', { [classNameWrapper]: classNameWrapper })}
               style={{ backgroundImage: `url(${bgImageUrl})` }}
          >
               <div className="container">
                    <div className="banner-left">
                         <h1 className="banner-title">{title}</h1>
                         <p className="banner-description">{description}</p>
                         {scrollSection && (
                              <div className="banner-scroll-section" onClick={handleClickScrollSection}>
                                   <span className="banner-scroll-text">{scrollSection.text}</span>
                                   <div className="banner-scroll-icon">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path
                                                  d={
                                                       isMobile
                                                            ? 'M8.49967 3.33301V12.6663M8.49967 12.6663L13.1663 7.99967M8.49967 12.6663L3.83301 7.99967'
                                                            : 'M8 1V15M8 15L15 8M8 15L1 8'
                                                  }
                                                  stroke="currentColor"
                                                  strokeWidth="2"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                             />
                                        </svg>
                                   </div>
                              </div>
                         )}
                    </div>
                    <div className="banner-right">
                         {trainingPathway && (
                              <div className="banner-training-pathway">
                                   <p className="banner-training-pathway-caption">{trainingPathway.caption}</p>
                                   <div className="banner-training-pathway-img">
                                        <img src={trainingPathway.image} alt={trainingPathway.caption} width="408" height="224" />
                                   </div>
                              </div>
                         )}
                    </div>
               </div>
          </section>
     );
};

Banner.defaultProps = {
     title: '',
     description: '',
     bgImageUrl: '',
     scrollSection: '',
};

export default Banner;
